import { COMMON } from 'translations';

import { getSingle } from '../../api/prismic';
import error, { getErrorObject } from '../../helpers/error';
import { HTTP_CLIENT_ERROR_NOT_FOUND } from '../../helpers/http';
import { toPrismicLang } from '../../helpers/i18n';
import { handleError } from '../errors';

export const LOAD_SINGLE_TYPE_DOC_REQUEST = 'LOAD_SINGLE_TYPE_DOC_REQUEST';
export const LOAD_SINGLE_TYPE_DOC_SUCCESS = 'LOAD_SINGLE_TYPE_DOC_SUCCESS';
export const LOAD_SINGLE_TYPE_DOC_FAILURE = 'LOAD_SINGLE_TYPE_DOC_FAILURE';

export const loadSingleTypeDocRequest = (lang, type) => ({
  type: LOAD_SINGLE_TYPE_DOC_REQUEST,
  id: type,
  lang,
});

export const loadSingleTypeDocSuccess = (lang, type, document) => ({
  type: LOAD_SINGLE_TYPE_DOC_SUCCESS,
  payload: document,
  id: type,
  lang,
});

export const loadSingleTypeDocFailure = (lang, type, error) => ({
  type: LOAD_SINGLE_TYPE_DOC_FAILURE,
  payload: getErrorObject(
    error,
    !error?.status ? COMMON.ERROR_LOADING_SINGLE_TYPE_DOC : undefined,
    {
      type,
    }
  ),
  id: type,
  lang,
});

export const getSingleTypeDocument = (type) => async (dispatch, getState) => {
  const { locale } = getState();
  const lang = toPrismicLang(locale);

  try {
    dispatch(loadSingleTypeDocRequest(locale, type));
    const document = await getSingle(type, { lang });
    if (!document?.result) {
      throw error(
        HTTP_CLIENT_ERROR_NOT_FOUND,
        `Document of type "${type}" couldn't be found`
      );
    }

    dispatch(loadSingleTypeDocSuccess(locale, type, document));
  } catch (error) {
    const fallback = loadSingleTypeDocFailure(locale, type, error);
    handleError(dispatch, error, fallback);
  }
};
